type PreviewPanePDFProps = {
  src: string;
};

export default function PreviewPaneImg({ src }: PreviewPanePDFProps) {
  return <iframe title="PreviewPanePDFFrame" src={src} width="100%" height="100%"></iframe>;
}
